import { Address } from '@vfde-sails/avc-core';
import { AddressForm, InputSuggestions } from '../interface';
import { JarvisResponse } from '../../../interface';

/**
 * Get an AddressForm object from available addresses and a selected index
 * @param {Address} address - selected address
 * @returns {AddressForm} - the AddressForm created from the selected address
 */
export const getAddressForm = (address: Address): AddressForm => ({
    city: address.city || '',
    street: address.street || '',
    housenumber: (address.housenumber || '') + (address.housenumberextra || ''),
});

/**
 * Get an address from the JarvisResponse to be used as selectedAddress.
 * Returns the address field if it is defined,
 * returns the first address in multi-address case
 * returns undefined otherwise.
 * @param {JarvisResponse} response - jarvis result object
 * @returns {Address | undefined}
 */
export const getSelectedAddress = (response: JarvisResponse) =>
    response.address ?? response.addresses?.[0];

export const getSuggestions = (form: AddressForm, suggestions: InputSuggestions): InputSuggestions => ({
    city: form.city ? suggestions.city : [],
    street: form.street ? suggestions.street : [],
});
